import { render, staticRenderFns } from "./assessment-fluctuation.vue?vue&type=template&id=f5ce8694&scoped=true&"
import script from "./assessment-fluctuation.vue?vue&type=script&lang=ts&"
export * from "./assessment-fluctuation.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-fluctuation.vue?vue&type=style&index=0&id=f5ce8694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ce8694",
  null
  
)

export default component.exports